export default "__VITE_ASSET__DHk$SyHv__"